<!--
 * @Author: wangwei
 * @Date: 2020-12-28 16:06:28
 * @LastEditTime: 2021-01-15 09:44:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /java-pc/src/views/member/order/List.vue
-->
<template>
  <div class="order_list_page">

    <div class="container">
      <h3>{{ L['订单管理'] }}</h3>
      <div class="order_nav flex_row_between_center">
        <div class="order_nav_con flex_row_start_center pointer">
          <div :class="{ item: true, active: current_state == '' }" @click="changeState('')">{{ L['全部订单'] }}</div>
          <div :class="{ item: true, active: current_state == 10 }" @click="changeState(10)">
            {{ L['待付款'] }}
            <!-- <div class="item_tag" :class="{ item_tag_one: memberInfo.toPaidOrder > 9, item_tag_two: memberInfo.toPaidOrder > 99 }"
              v-if="memberInfo.toPaidOrder > 0">{{ memberNumber('toPaidOrder') }}</div> -->
          </div>
          <div :class="{ item: true, active: current_state == 20 }" @click="changeState(20)">
            {{ L['待发货'] }}
            <!-- <div class="item_tag" :class="{
							item_tag_one: memberInfo.toDeliverOrder > 9,
							item_tag_two: memberInfo.toDeliverOrder > 99
						}" v-if="memberInfo.toDeliverOrder > 0">{{ memberNumber('toDeliverOrder') }}</div> -->
          </div>
          <div :class="{ item: true, active: current_state == 30 }" @click="changeState(30)">
            {{ L['待收货'] }}
            <!-- <div class="item_tag" :class="{
							item_tag_one: memberInfo.toReceivedOrder > 9,
							item_tag_two: memberInfo.toReceivedOrder > 99
						}" v-if="memberInfo.toReceivedOrder > 0">{{ memberNumber('toReceivedOrder') }}</div> -->
          </div>

        </div>
        <div class="search_con flex_row_start_center">
          <div class="search_incon flex_row_start_center">
            <el-input class="search_input" v-model="keyword" :placeholder="L['输入商品名称/订单编号']" clearable @clear="clear"></el-input>
            <div class="search pointer" @click="getOrderList">{{ L['搜索订单'] }}</div>
          </div>
        </div>
      </div>
      <div class=" all_order_info">
        <!-- <el-select v-model="selectTime" placeholder="请选择" @change="changeTime" v-if="selectList.data.length > 0" size="small" class="select_el"
          :popper-append-to-body="false">
          <el-option v-for="item in selectList.data" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select> -->
        <div class="list_header">

          <div class="list_header_details">{{ L['订单明细'] }}</div>
          <div class="list_header_money">{{ L['订单金额'] }}</div>
          <div class="list_header_state">{{ L['订单状态'] }}</div>
          <div class="list_header_operate">{{ L['操作'] }}</div>
        </div>

        <div class="list_content">
          <div class="list_content_item" v-for="(orderItem, index) in order_list.data" :key="index">
            <div class="list_item_header">
              <div class="list_item_header_number">

                <div class="item_heaeder_label">{{ L['订单时间'] }}: </div>
                <div class="item_heaeder_text">{{ orderItem.createTime }}</div>
                <div class="dividing_line"></div>
                <div class="item_heaeder_label">{{ L['订单编号'] }}: </div>
                <div class="item_heaeder_text" @click="goDetail(orderItem.orderSn)">{{ orderItem.orderSn }}</div>
              </div>
              <div class="list_item_header_operate">
                <img class="customer_img" src="@/assets/order/customer_service_icon.png" alt="">
                <div class="item_header_operate_msg" @click="goKefu(orderItem)">咨询客服</div>
                <div class="delete_img" alt="" @click.stop="operateBtn('delOrder',orderItem)" v-if="orderItem.orderState == 0||orderItem.orderState == 50">
                </div>
              </div>
            </div>
            <div class="list_item_table">
              <!-- 明细 -->
              <div class="item_table_details">
                <div class="table_details_goods"
                  v-for="(goodsItem, goodsIndex) in (orderItem.showMore ? orderItem.orderProductList : orderItem.orderProductList.slice(0, 6))"
                  :key="goodsIndex" @click="goDetail(orderItem.orderSn)">
                  <img class="goods_img" @click.stop="goProductDetail(goodsItem.productId)" :src="goodsItem.productImage" />
                  <div class="goods_msg">
                    <div class="goods_title" @click.stop="goProductDetail(goodsItem.productId)">
                      <span v-if="goodsItem.isGift==1" class="goods-tag">赠品</span>
                      <span v-else-if="goodsItem.cartType==2" class="goods-tag">增值服务</span>
                      <span v-else-if="goodsItem.cartType==3" class="goods-tag">搭配</span>
                      {{goodsItem.productShortTitle}}
                    </div>
                    <div class="goods_price">
                      <span>¥{{formatNumber(goodsItem.productShowPrice)}}</span>
                      <span>x{{goodsItem.productNum}}</span>
                    </div>
                    <div class="goods_status" v-if="goodsItem.afsStateValue">
                      {{goodsItem.afsStateValue}}
                    </div>
                    <div class="goods_status" v-if="orderItem.orderState == 11&&goodsItem.remainStartTime&&goodsItem.remainEndTime">
                      {{goodsItem.remainStartTime+ '~' +goodsItem.remainEndTime }}可付尾款
                    </div>

                  </div>
                </div>
                <div @click="shwoMoreGoods(index)" v-if="orderItem.orderProductList&&orderItem.orderProductList.length>6">
                  <div class="goods_more" v-if="!orderItem.showMore">
                    <span>查看更多商品</span>
                    <img src="@/assets/order/icon_right.png" alt="">
                  </div>
                </div>
              </div>
              <!-- 价格 -->
              <div class="item_table_other">

                <div class="item_table_td">
                  <div class="order_price_box">
                    <div class="order_money">{{'¥'+ formatNumber(orderItem.orderAmount)}}</div>
                    <!-- 定金 -->
                    <div class="order_front_money" v-if="orderItem.orderType==103">
                      <span v-if="orderItem.orderSubState==101">待付定金¥{{formatNumber(orderItem.orderAmount)}}</span>
                      <span v-if="orderItem.orderSubState==102">已付定金¥{{formatNumber(orderItem.paidAmount)}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 状态 -->
              <div class="item_table_other border_left">
                <div class="item_table_td ">
                  <div class="order_state">
                    <div class="color_other" :class="{
                      'color_red':orderItem.orderState==10||orderItem.orderState==11,'color_blue':orderItem.orderState==20||orderItem.orderState==30||orderItem.orderState==31
                    }">{{orderItem.orderStateValue}}</div>
                    <div @click="goDetail(orderItem.orderSn)">订单详情</div>
                  </div>
                </div>
              </div>
              <!-- 操作 -->
              <div class="item_table_other border_left">
                <div class="item_table_td">
                  <!-- 0元订单 -->
                  <div class="btn_box" v-if="orderItem.zeroAfsSn != '0'">
                    <!-- 待发货 orderState =  20-->
                    <template v-if="orderItem.orderState == 20">
                      <div class="btn_primary" @click.stop="operateBtn('receipt',orderItem)">确认收货</div>
                      <div class="btn_default" @click.stop="operateBtn('',orderItem)">查看物流</div>
                    </template>
                    <!-- 已发货订单 - 未签收  orderState = 30-->
                    <template v-if="orderItem.orderState == 30|| orderItem.orderState == 31">
                      <div class="btn_primary" @click.stop="operateBtn('receipt',orderItem)">确认收货</div>
                      <div class="btn_default" @click.stop="operateBtn('',orderItem)">查看物流</div>
                    </template>
                    <!-- 已发货订单 - 已签收  orderState = 40-->
                    <template v-if="orderItem.orderState == 40">
                      <!-- <div class="btn_border" @click.stop="operateBtn('',orderItem)">再次购买</div> -->
                    </template>
                  </div>

                  <div class="btn_box" v-else>

                    <!-- 已取消  orderState = 0-->
                    <template v-if="orderItem.orderState == 0">
                      <!-- <div class="btn_border" @click.stop="operateBtn('',orderItem)">再次购买</div> -->
                    </template>
                    <!-- 待付款 orderState = 10-->
                    <template v-if="orderItem.orderState == 10">
                      <div class="btn_primary" @click.stop="operateBtn('pay',orderItem)">立即支付</div>
                      <div class="btn_default" @click.stop="operateBtn('changeAddress',orderItem)">修改地址</div>
                      <div class="btn_default" @click.stop="operateBtn('cancelOrder',orderItem)">取消订单</div>
                    </template>
                    <!-- 等待支付尾款 -->
                    <template v-if="orderItem.orderState == 11">
                      <div class="btn_primary" :class="{'oopacity_primary' :!orderItem.canPay}"
                        @click.stop="orderItem.canPay?operateBtn('balancePayment',orderItem):null">支付尾款</div>
                    </template>
                    <!-- 待发货 orderState =  20-->
                    <template v-if="orderItem.orderState == 20">
                      <!-- <div class="btn_border" @click.stop="operateBtn('',orderItem)">催发货</div> -->
                      <div class="btn_default" v-if="orderItem.isAfs != 1" @click.stop="operateBtn('afterSale',orderItem)">申请退款</div>
                    </template>
                    <!-- 已发货订单 - 未签收  orderState = 30-->
                    <template v-if="orderItem.orderState == 30|| orderItem.orderState == 31">
                      <div class="btn_primary" @click.stop="operateBtn('receipt',orderItem)">确认收货</div>
                      <div class="btn_default" @click.stop="operateBtn('',orderItem)">查看物流</div>
                      <div class="btn_default" @click.stop="operateBtn('',orderItem)">查看发票</div>
                      <div class="btn_default" v-if="orderItem.isAfs != 1" @click.stop="operateBtn('afterSale',orderItem)">退款/售后</div>
                    </template>
                    <!-- 已发货订单 - 已签收  orderState = 40-->
                    <template v-if="orderItem.orderState == 40">
                      <!-- <div class="btn_border" @click.stop="operateBtn('',orderItem)">再次购买</div> -->
                      <div class="btn_default" @click.stop="operateBtn('',orderItem)">查看发票</div>
                      <div class="btn_default" v-if="orderItem.isAfs != 1" @click.stop="operateBtn('afterSale',orderItem)">退款/售后</div>
                    </template>

                    <!-- 已关闭  orderState = 50-->
                    <template v-if="orderItem.orderState == 50">
                      <!-- <div class="btn_border" @click.stop="operateBtn('',orderItem)">再次购买</div> -->
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!-- 关联view -->
            <view class="related_order" v-if="orderItem.subOrderCount>1&&orderItem.orderState == 10">点击付款时，关联订单将一起支付 </view>
          </div>
        </div>

      </div>

      <el-pagination background @current-change="handleCurrentChange" :currentPage="pageData.current" :page-size="pageData.pageSize"
        layout="prev, pager, next, " :total="pageData.total" :hide-on-single-page="true" class="flex_row_end_center"></el-pagination>
      <SldCommonEmpty v-if="order_list.data.length == 0" :tip="L['暂无订单～']" totalWidth="934px" />

      <!-- 取消理由弹窗 start -->
      <el-dialog :title="''" v-model="cancel_order" :width="760" customClass="cancel_order_box" :before-close="(current_reason_id = '')" lock-sroll="false">
        <template #title>
          <div class="dialog_title">选择取消原因</div>
        </template>
        <div class="cancel_list_con_box">

          <div class="cancel_list_con">
            <div v-for="(reasonItem, index) in cancel_list.data" :key="index" :class="{
						reason_item: true,
						active: current_reason_id == reasonItem.reasonId
					}" @click="selectReason(reasonItem.reasonId)">
              <span class="reason_text">{{ reasonItem.content }}</span>

            </div>
          </div>
        </div>
        <div class="confirm_cancel_btn_box">
          <div class="confirm_cancel_btn" :class="{confirm_cancel_btn_opacity:!current_reason_id}" @click="confirmCancel()">{{ L['确定'] }}</div>
        </div>
      </el-dialog>
      <!--  取消地址理由弹窗 end  -->

      <!-- 地址选择弹窗 start -->
      <el-dialog :title="''" v-model="show_select_address" class="select_address_width" customClass="select_address_width" lock-sroll="false">
        <template #title>
          <div class="dialog_title">{{L['修改地址']}}</div>
        </template>
        <div>
          <div class="address_con_box">
            <div v-for="(item, index) in address_list.data" :key="index" @click="selectAddress(index)" :class="{
							address_item: true,
							select: current_address_index == index
						}">
              <div class="address_item_top">
                <span>{{ item.memberName }}</span>
                <span>{{ item.telMobile }}</span>
                <span class="address_tag" v-if="item.isDefault ==1">默认地址</span>
              </div>
              <div class="address_item_detail">
                {{ item.addressAll }} {{ item.detailAddress }}
              </div>

            </div>

          </div>
          <div class="confirm_address_btn_box">
            <div class="confirm_cancel_btn" @click="confirmChangeAddress()">{{ L['确定'] }}</div>
          </div>
        </div>
      </el-dialog>
      <!-- 地址选择弹窗 end -->

      <!-- 全部按钮弹窗 start -->
      <el-dialog :title="''" v-model="show_all_order" :width="760" :before-close="closeAllOrder" lock-sroll="false" center>
        <template #title>
          <div class="dialog_title">以下订单需一起付款</div>
        </template>

        <div class="all_order_con">
          <div class="all_order_item" v-for="(v,i) in all_order_data.orderList" :key="i">
            <div class="all_order_item_top">
              <div class="all_order_item_no">{{v.orderSn}}</div>
              <div class="all_order_item_money">¥{{v.orderAmount}}</div>
            </div>
            <div class="all_order_item_count">共({{v.goodsNum}})件</div>
          </div>
          <div class="all_order_line"></div>
          <div class="all_order_item" style="margin-bottom:0px">
            <div class="all_order_item_top">
              <div class="all_order_item_no">合计</div>
              <div class="all_order_item_money">¥{{all_order_data.totalAmount}}</div>
            </div>
          </div>
        </div>

        <template #footer>
          <div class="dialog-footer">
            <el-button class="confirm_primary_btn" type="primary" @click="closeAllOrder(1)">确定</el-button>

          </div>
        </template>
      </el-dialog>
      <!-- 全部按钮弹窗 end -->
    </div>
  </div>
</template>
<script>
import { reactive, getCurrentInstance, ref, onMounted, computed } from 'vue'
import {
  ElInput,
  ElMessage,
  ElMessageBox,
  ElTimeline,
  ElTimelineItem
} from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import SldCommonEmpty from '../../../components/SldCommonEmpty'
import MemberTitle from '../../../components/MemberTitle'
export default {
  name: 'order-list',
  components: {
    ElInput,
    ElTimeline,
    ElTimelineItem,
    SldCommonEmpty,
    MemberTitle
  },
  setup () {
    // const balance = require("../../assets/buy/balance.png");
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const current_state = ref('') //当前列表订单状态
    const evaluate_state = ref(0) //是否是待评价
    const order_list = reactive({ data: [] })
    const orderSn = ref('')
    const cancel_order = ref(false) //是否显示取消订单弹窗
    const not_select = require('../../../assets/order/not_select.png')
    const selected = require('../../../assets/order/selected.png')
    const invoice_selected = require('../../../assets/buy/invoice_selected.png')
    const cancel_list = reactive({ data: [] })
    const current_reason_id = ref() //记录当前已选择理由id
    const order_sn = ref() //记录当前操作的订单号
    const parentOrderSn = ref()
    const show_select_address = ref(false) //是否显示选择地址弹窗
    const address_list = reactive({ data: [] }) //地址列表
    const current_address_index = ref(0) //记录当前选择的地址
    const selectTime = ref('')
    const selectList = reactive({ data: [] })
    const pageData = reactive({
      current: 1,
      pageSize: 10,
      total: 0
    })
    const keyword = ref('')
    const memberInfo = computed(() => store.state.memberInfo)


    const orderDetail = ref(); // 点击按钮订单
    const all_order_data = ref({}); // 全部相关订单
    const show_all_order = ref(false); // 全部相关订单展示
    //去商品详情页
    const goGoodsDetail = productId => {
      proxy.$goGoodsDetail(productId)
    }
    //去店铺详情
    const toStore = storeId => {
      if (storeId == 0) {
        return
      }
      proxy.$goStoreDetail(storeId)
    }
    //获取下拉时间
    const getTime = () => {
      proxy.$get('v3/business/front/orderInfo/timeList').then(res => {
        if (res.data.length > 0) {
          selectList.data = res.data
          selectTime.value = selectList.data[0].id
        }
      })
    }



    /**
     * 判断传入数据是否为数字类型的字符串或数字。
     * 如果是，则保留两位小数；如果不是，则直接返回原数据。
     * @param {any} value - 传入的数据
     * @returns {string|number|any} - 格式化后的数据或原数据
     */
    const formatNumber = (value) => {
      // 判断是否为数字类型的字符串或数字
      if (typeof value === 'number' || !isNaN(Number(value))) {
        // 转换为数字并保留两位小数
        return Number(value).toFixed(2);
      }
      // 如果不是数字类型，直接返回原数据
      return value;
    };

    // 点击操作栏按钮
    const operateBtn = (btnType, orderItem) => {
      orderDetail.value = orderItem;
      console.log("operateBtn click_-------->", btnType, orderItem)
      if (btnType == 'pay') {
        // 合并支付
        if (orderItem.subOrderCount > 1) {
          getParentOrder(orderItem);// 获取父订单
          return
        }

        goPay(orderItem.paySn)
        return
      }
      if (btnType == 'cancelOrder') { // 取消订单
        showSelectReasonDialog(orderItem)
        return;
      }
      if (btnType == 'balancePayment') { // 支付尾款
        goPayBalance(orderItem);
        return
      }
      if (btnType == 'changeAddress') { // 修改地址
        editAddress(orderItem);
        return
      }
      if (btnType == 'receipt') { // 确认收货
        confirmReceipt(orderItem.orderSn)
        return
      }
      if (btnType == 'delOrder') { // 删除订单
        delOrder(orderItem.orderSn)
        return
      }

      if (btnType == 'afterSale') { // 退换售后
        console.log("afterSale-------->", orderItem)
        let oderType;
        switch (orderItem.orderState) {
          case 20: // 待发货
            oderType = 1;
            break;
          case 30: // 待收货
            oderType = 2;
            break;
          case 31: // 待收货
            oderType = 2;
            break;
          case 40: // 已完成
            oderType = 3;
            break;
          default:
            // 处理其他情况，可选
            console.log('未知的 orderState');
            break;
        }
        router.push({
          path: '/member/order/refund/apply',
          query: {
            orderSn: orderItem.orderSn,
            orderType: oderType,///*orderType	1-待发货  2-待收货  3-已完成*/

          }
        })
        return
      }

      ElMessage("功能暂未开发，敬请期待")
    }


    //切换搜索时间
    const changeTime = () => {
      resetPageData()
      getOrderList()
    }
    //重置搜索页面数据
    const resetPageData = () => {
      pageData.current = 1
      pageData.total = 0
    }
    //改变订单状态
    const changeState = (orderState, evaluateState) => {
      if (evaluateState) {
        evaluate_state.value = evaluateState
      } else {
        evaluate_state.value = ''
      }
      current_state.value = orderState
      pageData.current = 1
      router.push({
        path: '/member/order/list',
        query: {
          orderState,
          evaluateState
        }
      })
      getOrderList()
    }
    //获取订单列表
    const getOrderList = () => {
      var param = {}
      if (evaluate_state.value == 1) {
        param.evaluateState = 1
      }
      if (current_state.value) {
        param.orderState = current_state.value
      }
      param.current = pageData.current
      param.pageSize = pageData.pageSize
      if (orderSn.value) {
        param.orderSn = orderSn.value
      }
      param.time = selectTime.value
      if (keyword.value) {
        param.keyword = keyword.value
      }
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      proxy
        .$post('v3/business/front/orderInfo/list', param, config)
        .then(res => {
          if (res.state == 200) {

            order_list.data = res.data.list

            order_list.data.forEach(item => {
              if (item.orderProductList && item.orderProductList.length > 6) {
                item.showMore = false; // 展示更多按钮 默认收起
              }
              if (item.orderType == 103 && item.orderState == 11) { // 定金订单 待付尾款
                const now = new Date().getTime();
                const targetDate = new Date(item.payStartTime).getTime();

                item.canPay = now > targetDate;

                // console.log(item)
              }
            })

            console.log("res--->", order_list)

            pageData.total = res.data.pagination.total
          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }
    const shwoMoreGoods = (index) => {
      // console.log("moreClick------->",order_list.data[index]);
      order_list.data[index].showMore = !order_list.data[index].showMore;
    }
    // 获取订单取消理由列表
    const getCancelList = () => {
      proxy
        .$get('v3/system/front/reason/list', {
          type: 104
        })
        .then(res => {
          if (res.state == 200) {
            cancel_list.data = res.data
          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }
    //选择理由
    const selectReason = id => {
      current_reason_id.value = id
    }
    //显示选择理由弹窗
    const showSelectReasonDialog = orderItem => {
      if (
        !orderItem.isRefundDeposit &&
        (orderItem.orderType == 105 || orderItem.orderType == 103) &&
        orderItem.orderSubState == 102
      ) {
        ElMessageBox.confirm(L['取消该订单定金不予退还,确定取消?'], L['提示'], {
          confirmButtonText: L['确定'],
          cancelButtonText: L['取消'],
          type: 'warning'
        }).then(() => {
          cancel_order.value = true
          parentOrderSn.value = orderItem.parentSn
        })
      } else {
        cancel_order.value = true
        parentOrderSn.value = orderItem.parentSn
      }
    }
    //显示查看物流信息
    const lookLogistics = orderSn => {
      router.push(`/member/order/detail?orderSn=${orderSn}#logistics`)
    }

    //删除订单
    const delOrder = orderSn => {
      ElMessageBox.confirm(L['确认删除该订单?'], L['提示'], {
        confirmButtonText: L['确定'],
        cancelButtonText: L['取消'],
        type: 'warning'
      })
        .then(() => {
          proxy
            .$post('v3/business/front/orderOperate/delete', {
              orderSn
            })
            .then(res => {
              if (res.state == 200) {
                ElMessage.success(L['删除订单成功'])
                getOrderList()
                getInitInfo()
              } else {
                ElMessage(res.msg)
              }
            })
            .catch(() => {
              //异常处理
            })
        })
        .catch(() => { })
    }
    //确认取消订单
    const confirmCancel = () => {
      if (!current_reason_id.value) {
        ElMessage.warning(L['请选择取消理由'])
        return
      }
      proxy
        .$post('v3/business/front/orderOperate/cancel', {
          parentSn: parentOrderSn.value,
          reasonId: current_reason_id.value
        })
        .then(res => {
          if (res.state == 200) {
            ElMessage.success(L['取消订单成功'])
            cancel_order.value = false
            getOrderList()
            getInitInfo()
          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }
    //确认收货
    const confirmReceipt = orderSn => {
      ElMessageBox.confirm(L['确认收货?'], L['提示'], {
        confirmButtonText: L['确定'],
        cancelButtonText: L['取消'],
        type: 'warning'
      }).then(() => {
        proxy
          .$post('v3/business/front/orderOperate/receive', {
            orderSn
          })
          .then(res => {
            if (res.state == 200) {
              ElMessage.success(L['确认收货成功'])
              getOrderList()
              getInitInfo()
            } else {
              ElMessage(res.msg)
            }
          })
      })
    }
    //立即支付
    const goPay = orderSn => {
      router.push({
        path: '/buy/pay',
        query: {
          paySn: orderSn,
          payFrom: 2
        }
      })
    }
    const getParentOrder = orderItem => {

      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let param = {};
      param.parentSn = orderItem.parentSn;
      proxy
        .$post('v3/business/front/orderInfo/detailParent', param, config)
        .then(res => {
          if (res.state == 200) {
            all_order_data.value = res.data;
            show_all_order.value = true;

          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }
    const closeAllOrder = (payType) => {
      show_all_order.value = false
      if (payType == 1) {
        console.log("roderDetail--->", orderDetail.value.paySn)
        goPay(orderDetail.value.paySn)
        all_order_data.value = {};
      }
    }

    // 支付尾款
    const goPayBalance = orderItem => {
      console.log("productItem--->", orderItem)
      let mainProduct = orderItem.orderProductList.filter(item => item.cartType == 1 && item.isGift === 0)

      let query = {}
      query.productId = mainProduct[0].productId;
      query.orderSn = orderItem.orderSn;
      query.promotionType = mainProduct[0].promotionType;
      router.push({
        path: '/buy/confirm',
        query: query,
      })
    }
    //选择地址
    const editAddress = order => {
      show_select_address.value = true
      order_sn.value = order.orderSn

      let {
        receiverAddress,
        receiverAreaInfo,
        receiverMobile,
        receiverName
      } = order

      let index = address_list.data.findIndex(i => {
        let { addressAll, memberName, telMobile, detailAddress } = i
        if (
          memberName == receiverName &&
          receiverMobile == telMobile &&
          receiverAddress == detailAddress &&
          addressAll == receiverAreaInfo
        ) {
          return true
        } else {
          return false
        }
      })

      if (index > -1) {
        current_address_index.value = index
      } else {
        current_address_index.value = -1
      }
    }
    //获取地址列表
    const getAddressList = () => {
      proxy.$get('v3/member/front/memberAddress/list').then(res => {
        if (res.state == 200) {
          address_list.data = res.data.list
        } else {
          ElMessage(res.msg)
        }
      })
    }
    //切换地址
    const selectAddress = index => {
      current_address_index.value = index
    }
    //确认修改地址
    const confirmChangeAddress = () => {
      proxy
        .$post('v3/business/front/orderOperate/updateAddress', {
          orderSn: order_sn.value,
          addressId: address_list.data[current_address_index.value].addressId
        })
        .then(res => {
          if (res.state == 200) {
            ElMessage.success(L['切换地址成功'])
            show_select_address.value = false
          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }
    //评价订单
    const remainEvaluated = orderSn => {
      router.push({
        path: '/member/order/evaluate',
        query: {
          orderSn: orderSn
        }
      })
    }
    //详情
    const goDetail = orderSn => {
      router.push({
        path: '/member/order/detail',
        query: {
          orderSn: orderSn
        }
      })
    }
    //向前翻页
    const handlePrevCilickChange = e => {
      pageData.current = e
      getOrderList()
    }
    //向后翻页
    const handleNextCilickChange = () => {
      pageData.current++
      getOrderList()
    }
    //页数改变
    const handleCurrentChange = current => {
      pageData.current = current
      getOrderList()
    }
    const getInitInfo = () => {
      //获取会员信息数据
      proxy.$get('v3/member/front/member/getInfo').then(res => {
        if (res.state == 200) {
          memberInfo.value = Object.assign(memberInfo.value, res.data)
          store.commit('updateMemberInfo', memberInfo.value) //将购物车数据存储到vuex的store中
        }
      })
    }
    onMounted(() => {
      if (route.query.orderState) {
        current_state.value = route.query.orderState
      } else {
        current_state.value = ''
      }
      if (route.query.evaluateState) {
        evaluate_state.value = route.query.evaluateState
      } else {
        evaluate_state.value = ''
      }
      getTime()
      getOrderList()
      getCancelList()
      getAddressList()
    })
    //清空搜索订单
    const clear = () => {
      orderSn.value = ''
      getOrderList()
    }

    const toKefu = item => {
      let chatInfo = {
        storeId: item.storeId,
        vendorAvatar: item.storeLogo,
        storeName: item.storeName,
        source: L['从订单列表进入']
      }
      store.commit('saveChatBaseInfo', chatInfo)

      let newWin = router.resolve({
        path: '/service',
        query: {
          vid: item.storeId
        }
      })

      window.open(newWin.href, '_blank')
    }

    const memberNumber = type => {
      return memberInfo.value[type] < 99 ? memberInfo.value[type] : '99+'
    }
    const goProductDetail = (productId) => {
      let newWin = router.resolve({
				path: `/goods/detail`,
				query: {productId:productId}
			})
			window.open(newWin.href, '_blank')
      //window.open(`/goods/detail?productId=${productId}`, '_blank');
    }
    const goKefu = (orderItem) => {
      console.log("orderItem--->", orderItem);
      // return
      // 客服暂时只接收商品级，所以只传第一个主商品
      let param = {
        productId: orderItem.orderProductList[0].productId,
      }
      proxy.$gotokefu(param);
    }


    router.beforeEach((to, from, next) => {
      if (to.query.orderState) {
        current_state.value = to.query.orderState
      } else {
        current_state.value = ''
      }
      if (to.query.evaluateState) {
        evaluate_state.value = to.query.evaluateState
      } else {
        evaluate_state.value = ''
      }
      if (to.path == '/member/order/list') {
        getOrderList()
        getInitInfo()
      }
      next()
    })
    return {
      current_state,
      changeState,
      evaluate_state,
      getOrderList,
      order_list,
      orderSn,
      cancel_order,
      not_select,
      selected,
      cancel_list,
      current_reason_id,
      selectReason,
      confirmCancel,
      showSelectReasonDialog,
      delOrder,
      lookLogistics,
      confirmReceipt,
      goPay,
      show_select_address,
      address_list,
      invoice_selected,
      current_address_index,
      selectAddress,
      editAddress,
      confirmChangeAddress,
      remainEvaluated,
      goDetail,
      L,
      goGoodsDetail,
      toStore,
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange,
      pageData,
      clear,
      toKefu,
      selectTime,
      selectList,
      getTime,
      changeTime,
      resetPageData,
      keyword,
      memberInfo,
      memberNumber,
      shwoMoreGoods,
      operateBtn,
      closeAllOrder,
      all_order_data,
      show_all_order,
      goProductDetail,
      goKefu,
      formatNumber
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../style/orderList.scss";

.el-pager li.active {
  // color: var(--color_main);
  cursor: default;
}

.no_logistics {
  text-align: center;
  padding-top: 100px;
}

.view_more {
  text-align: center;
  margin-top: 10px;

  span {
    cursor: pointer;
  }
}

.order_list_page {
  width: 1106px;
  margin-left: 10px;
  float: left;

  .container {
    padding: 0px;
    background-color: #fff;
    margin-bottom: 10px;

    h3 {
      border: none;
      padding: 30px;

      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 500;
      font-size: 18px;
      color: #000000;
      line-height: 26px;
    }
    .order_nav {
      .order_nav_con {
        padding: 18px 30px;
        .item {
          padding: 0 15px;
          background: rgba(234, 237, 240, 0.4);
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 15px;
          color: #888e98;
          line-height: 28px;
          margin-right: 15px;
          position: relative;
        }
        .active {
          color: #ffffff;
          background: #000000;
        }

        .item_tag {
          position: absolute;
          background-color: red;
          color: #fff;
          top: -8px;
          right: -8px;
          height: 18px;
          display: flex;
          line-height: 19px;
          justify-content: center;
          border-radius: 18px;
          font-size: 12px;
          text-align: center;
          padding: 0 5px;
          font-weight: 500;
        }
      }
      .search_con {
        padding: 18px 30px;
        .search_input {
          ::v-deep .el-input__inner {
            height: 36px;
            border-radius: 0px;
          }
        }
        .search {
          flex-shrink: 0;
          width: 80px;
          height: 36px;
          text-align: center;
          background: #eaedf0;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #000000;
          line-height: 36px;
        }
      }
    }

    .all_order_info {
      position: relative;
      padding: 30px;
      .list_header {
        width: 100%;
        height: 44px;
        background: #f1f3f5;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 15px;
        color: #888e98;
        line-height: 24px;
        text-align: center;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        margin-bottom: 20px;
        > div {
          flex-shrink: 0;
        }
        .list_header_details {
          // width: 566px;
          flex-grow: 1;
        }
        .list_header_money {
          width: 160px;
        }
        .list_header_state {
          width: 160px;
        }
        .list_header_operate {
          width: 160px;
        }
      }
    }
    .list_content {
      position: relative;
      .list_content_item {
        margin-bottom: 20px;
        .list_item_header {
          display: flex;
          justify-content: space-between;
          width: 100%;
          height: 40px;
          padding: 0 20px;
          background: #f1f3f5;
          .list_item_header_number {
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 15px;
            line-height: 24px;
            .item_heaeder_label {
              color: #888e98;
            }
            .item_heaeder_text {
              color: rgba(0, 0, 0, 0.7);
            }
            .dividing_line {
              width: 1px;
              height: 20px;
              background: #d9d9d9;
              margin: 0 15px;
            }
          }
          .list_item_header_operate {
            display: flex;
            align-items: center;
            .customer_img {
              width: 20px;
              height: 20px;
            }
            .delete_img {
              width: 20px;
              height: 20px;
              margin-left: 40px;
              background-image: url("../../../assets/order/delete_icon.png"); /* 默认图片 */
              background-size: cover; /* 确保图片覆盖整个容器 */
              background-position: center; /* 图片居中 */
            }
            .delete_img:hover {
              background-image: url("../../../assets/order/delete_icon_active.png"); /* 默认图片 */
            }
            .item_header_operate_msg {
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: 12px;
              color: #000000;
              line-height: 18px;
              margin-left: 5px;
              cursor: default;
            }
          }
        }

        .list_item_table {
          box-sizing: border-box;
          width: 100%;
          min-height: 140px;
          border: 1px solid #f1f3f5;
          border-top: none;
          display: flex;
          // align-items: center;
          align-items: stretch; /* 确保子元素填充整个交叉轴 */
          flex-wrap: nowrap;

          .item_table_details {
            // height: 500px;
            height: 100%;
            min-height: 140px;
            flex-grow: 1;
            border-right: 1px solid #f1f3f5;
            .table_details_goods {
              min-height: 140px;
              padding: 20px;
              display: flex;
              align-items: center;
              border-bottom: 1px solid #f1f3f5;
              .goods_img {
                width: 100px;
                height: 100px;
                flex-shrink: 0;
              }
              .goods_msg {
                flex-grow: 1;
                padding-left: 20px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                .goods_title {
                  font-weight: 400;
                  font-size: 15px;
                  color: rgba(0, 0, 0, 0.7);
                  line-height: 24px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2; /* 设置最大行数 */
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-height: 48px;
                  .goods-tag {
                    background: rgba(217, 217, 217, 0);
                    border-radius: 2px;
                    border: 1px solid #1e7cff;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #1e7cff;
                    line-height: 16px;
                    padding: 0 5px;
                  }
                }
                .goods_price {
                  font-weight: 400;
                  font-size: 15px;
                  color: rgba(0, 0, 0, 0.7);
                  line-height: 24px;
                  margin-top: 10px;
                  > :first-child {
                    margin-right: 10px;
                  }
                }
                .goods_status {
                  font-family: Microsoft YaHei, Microsoft YaHei;
                  font-weight: 400;
                  font-size: 12px;
                  color: #df443b;
                  line-height: 24px;
                }
              }
            }
            > .table_details_goods:last-child {
              border: none; /* 移除边框 */
              margin-bottom: 0; /* 移除底部间距（如果有的话） */
            }
            .goods_more {
              height: 64px;
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: 15px;
              color: rgba(0, 0, 0, 0.7);
              line-height: 24px;
              cursor: default;
              > img {
                width: 14px;
                height: 14px;
                margin-left: 6px;
              }
            }
          }
          .item_table_other {
            // height: 100%;
            min-height: 140px;
            flex-shrink: 0;
            width: 160px;
          }
          .item_table_td {
            // height: 100%;
            min-height: 140px;
            flex-shrink: 0;
            width: 160px;
            display: flex;
            align-items: center;
          }
          .border_left {
            border-left: 1px solid #f1f3f5;
          }
          .order_price_box {
            width: 100%;
            display: flex;
            flex-direction: column;
            cursor: default;
            .order_front_money {
              width: 100%;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: 12px;
              color: #df443b;
              line-height: 24px;
              text-align: center;
            }
            .order_money {
              width: 100%;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: 15px;
              color: rgba(0, 0, 0, 0.7);
              line-height: 24px;
              text-align: center;
            }
          }
          .order_state {
            width: 100%;
            display: flex;
            flex-direction: column;
            cursor: default;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 15px;
            color: #7e91bc;
            line-height: 24px;
            text-align: center;
            > div {
              margin-bottom: 2px;
            }

            .color_other {
              color: rgba(0, 0, 0, 0.7);
            }
            .color_red {
              color: #df443b;
            }
            .color_blue {
              color: #1e7cff;
            }
          }
          .btn_box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-size: 15px;
            font-weight: 400;
            line-height: 24px;

            text-align: center;
            cursor: default;
            > div {
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .btn_primary {
              width: 100px;
              height: 34px;
              background: #1e7cff;
              border-radius: 2px;
              border: 1px solid #1e7cff;
              color: #ffffff;
              text-align: center;
            }
            .oopacity_primary {
              opacity: 0.5;
            }
            .btn_default {
              width: 140px;
              height: 24px;
              font-family: Microsoft YaHei, Microsoft YaHei;
              color: #7e91bc;
              text-align: center;
              margin-top: 10px;
            }
            .btn_border {
              width: 100px;
              height: 34px;
              border-radius: 2px;
              border: 1px solid #1e7cff;
              color: #1e7cff;
            }
          }
        }
        .related_order {
          width: 100%;
          height: 44px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #df443b;
          line-height: 42px;
          border: 1px solid #f1f3f5;
          border-top: 0px;
          padding-left: 15px;
          display: block;
        }
      }
    }
  }
}

::v-deep .select_reason_width {
  width: 760px !important;

  ::-webkit-scrollbar {
    width: 0 !important;
  }

  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0;
  }
}
.cancel_list_con_box {
  height: 300px;
  overflow-y: auto;
  .cancel_list_con {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 10px;
    //
    overflow-y: auto;
    .reason_item {
      height: 44px;
      width: 342px;
      margin-bottom: 20px;
      border-radius: 1px 1px 1px 1px;
      border: 1px solid #e0e0e0;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 15px;
      color: rgba(0, 0, 0, 0.7);
      line-height: 42px;
      text-align: center;

      &.active {
        // background: #f8f8f8;
        border: 1px solid #1e7cff;
        color: #000000;
      }
    }
  }
}
.logistics_list_con {
  width: 520px;
  margin: 0 auto;
  height: 300px;
  overflow-y: scroll;
  padding-top: 1px;

  .reason_item {
    padding: 0 30px;
    height: 40px;
    width: 100%;
    margin-bottom: 15px;

    img {
      width: 18px;
      height: 18px;
    }

    &.active {
      background: #f8f8f8;
    }
  }
}

.confirm_address_btn_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.confirm_cancel_btn_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirm_cancel_btn {
  width: 150px;
  height: 46px;
  background: #1e7cff;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #1e7cff;
  cursor: default;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
}
.confirm_cancel_btn_opacity {
  opacity: 0.5;
}
::v-deep .select_address_width {
  width: 880px !important;
}
::v-deep .select_address_width {
  .el-dialog__body {
    padding: 20px 0 0 0 !important;
  }
}
// 选择地址
.address_con_box {
  height: 344px;
  overflow-y: auto;
  width: 100%;
  margin: 0 auto;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  &::-webkit-scrollbar {
    width: 4px !important;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #e7e9eb; /* 滑块颜色 */
    border-radius: 10px; /* 圆角程度 */
  }

  .address_item {
    flex-shrink: 0;
    &:not(:nth-child(-n + 2)) {
      margin-top: 20px;
    }

    width: 400px;
    height: 127px;
    box-sizing: border-box;
    border: 1px solid #e0e0e0;
    position: relative;
    padding: 20px;
    cursor: default;

    .address_item_top {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 15px;
      color: rgba(0, 0, 0, 0.7);
      line-height: 24px;
      text-align: left;
      display: flex;
      align-items: center;
      > span {
        margin-right: 15px;
      }
      > .address_tag {
        font-weight: 500;
        font-size: 12px;
        color: #1e7cff;
        line-height: 18px;
        text-align: left;
        height: 20px;
        background: #ffffff;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #1e7cff;
      }
    }
    .address_item_detail {
      margin-top: 15px;
      width: 100%;
      height: 48px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 500;
      font-size: 15px;
      color: #000000;
      line-height: 24px;
      text-align: left;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 设置你希望的最大行数 */
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word; /* 强制换行 */
    }
  }

  .select {
    border: 1px solid #1e7cff;
  }
}

.confirm_primary_btn {
  width: 150px;
  height: 46px;
  background: #1e7cff;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #1e7cff;
  font-size: 18px;
}
.dialog_title {
  text-align: center;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 500;
  font-size: 20px;
  color: #000000;
  line-height: 26px;
  padding: 30px 0 0 0;
}
.all_order_con {
  position: relative;
  .all_order_item {
    margin-bottom: 20px;
    .all_order_item_top {
      display: flex;
      justify-content: space-between;
      .all_order_item_no {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 15px;
        color: #000000;
        line-height: 26px;
      }
      .all_order_item_money {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 15px;
        color: #df443b;
        line-height: 26px;
      }
    }
    .all_order_item_count {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 15px;
      color: #888e98;
      line-height: 24px;
    }
  }
  .all_order_line {
    width: 100%;
    height: 1px;
    background: #eaedf0;
    margin-bottom: 20px;
  }
}
</style>
